import {
  identifyLogRocketUser,
  initializeLogRocket,
  trackLogRocketEvent
} from "./chunk-HQNAMWRU.mjs";
import {
  createSegmentClient
} from "./chunk-QN7COP2I.mjs";

// src/selectors.ts
var selectUserId = (state) => {
  return state.account.userId || "";
};
var selectAccountId = (state) => {
  return state.account.accountId || "";
};
var selectEmail = (state) => {
  return state.account.email;
};
var selectIsSpoofing = (state) => {
  return state.account.isSpoofing || false;
};
var selectName = (state) => {
  return state.account.name;
};
var selectCompany = (state) => {
  return state.account.company;
};

// src/client.ts
var createAnalyticsClient = (state, baseProperties = {}, clientMode = false, config = {}) => {
  const segmentClient = createSegmentClient(
    {
      userId: selectUserId(state),
      accountId: selectAccountId(state),
      isSpoofing: selectIsSpoofing(state),
      email: selectEmail(state)
    },
    clientMode
  );
  const userId = selectUserId(state);
  const isSpoofing = selectIsSpoofing(state);
  if (config.logrocket && !isSpoofing) {
    initializeLogRocket(config.logrocket);
    const accountId = selectAccountId(state);
    const email = selectEmail(state);
    const name = selectName(state);
    const company = selectCompany(state);
    identifyLogRocketUser(String(userId), {
      name: name || email || "Unknown",
      email: email || "unknown@appcues.com",
      accountId: accountId || "unknown",
      company: company || "Unknown"
    });
  }
  const identifyProps = {
    identifyUserId: userId,
    traits: {
      env: import.meta.env.APPCUES_ENV,
      accountId: selectAccountId(state),
      email: selectEmail(state)
    }
  };
  segmentClient.identify(identifyProps);
  return {
    page: () => {
      segmentClient.page();
    },
    track: (type, properties = {}) => {
      const resolvedBaseProperties = Object.entries(baseProperties).reduce(
        (acc, [key, value]) => {
          acc[key] = typeof value === "function" ? value() : value;
          return acc;
        },
        {}
      );
      const flattenedProperties = {
        ...resolvedBaseProperties
      };
      if (flattenedProperties.experience && typeof flattenedProperties.experience === "object" && "id" in flattenedProperties.experience && "type" in flattenedProperties.experience) {
        const { id, type: experienceType } = flattenedProperties.experience;
        flattenedProperties.experienceId = id;
        flattenedProperties.experienceType = experienceType;
        delete flattenedProperties.experience;
      }
      segmentClient.track({
        name: type,
        ...properties,
        ...flattenedProperties
      });
      trackLogRocketEvent(type, {
        ...properties,
        ...flattenedProperties
      });
    }
  };
};
export {
  createAnalyticsClient
};
//# sourceMappingURL=client.mjs.map